export default "__VITE_ASSET__43166d79__"